import React, { useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import PGARecentHistoryTable from "./PGARecentHistoryTable";
import Button from "../../Button";
import "./PGARecentHistory.css";

const GET_PGA_RECENT_HISTORY = graphql`
  query PGARecentHistoryQuery($playerId: ID!, $count: Int) {
    ...PGARecentHistoryTable_query
      @arguments(playerId: $playerId, count: $count)
  }
`;

export default function PGARecentHistory({ playerId, showMore, fetchNum }) {
  let count = 10;

  if (showMore) {
    count = 25;
  }

  const queryData = useLazyLoadQuery(
    GET_PGA_RECENT_HISTORY,
    {
      playerId: playerId,
      count: count,
    },
    { fetchPolicy: "network-only", fetchKey: fetchNum }
  );

  return (
    <div>
      <PGARecentHistoryTable
        playerId={playerId}
        query={queryData}
        showMore={showMore}
      />
    </div>
  );
}
